import * as React from "react"
import type {HeadFC, PageProps} from "gatsby"
import {DefaultLayout} from "../components/DefaultLayout/DefaultLayout";
import {graphql} from "gatsby";
import {Container, SimpleGrid} from "@mantine/core";
import PostCard from "../components/PostCard/PostCard";

const IndexPage: React.FC<PageProps<Queries.IndexPageQuery>> = ({data}) => {
    return (
        <DefaultLayout>

            <Container size={"xl"}>

                <h1>Гайды, прокачки, таланты и коды в Rise of Kingdoms</h1>

                <SimpleGrid breakpoints={[
                    {minWidth: 'sm', cols: 2},
                    {minWidth: 'md', cols: 3},
                  //  {minWidth: "xl", cols: 3},
                ]}>
                    {data.posts.nodes.map(post => (
                        <PostCard post={post}/>
                    ))}
                </SimpleGrid>

            </Container>

        </DefaultLayout>
    )
}

export const query = graphql`
    query IndexPage {
        posts: allContentfulBlogPost(sort: [{updatedAt: DESC}]) {
            nodes {
                title
                slug
                featured_image {
                    title
                    gatsbyImageData(
                        cornerRadius: 10,
                    )
                }
            }
        }
    }
`

export default IndexPage

export const Head: HeadFC = () => <title>Гайды, прокачки, таланты и коды в Rise of Kingdoms</title>
